export enum AppPref {
	CONTACT_EMAIL = 'email.mailto.rcpt_to',
	HELP_URL = 'app.helpUrl',
}

export enum AppCombinedMenuItemsSection {
	MAIN = 'main',
	SYSTEM = 'system',
	TOOLS = 'tools',
	USER = 'user',
	SIGN_OUT = 'signOut',
}
